import React from 'react';
import ReferenceGenerator from '../../../components/ReferenceGenerator';
import { WASTE_CONDITION_TYPES } from '../../../constants/enums';

export default function WasteConditionsReferencePage() {
  return (
    <ReferenceGenerator url={WASTE_CONDITION_TYPES} importKind={WASTE_CONDITION_TYPES} />
  );
}
